import React, { Component } from 'react'

export default class TimeCard extends Component {
    state = {
        date: Date(), data: '', hr: '', min: '', sec: '',mil: ''
    }
    date = () => {
        var hr, min, sec, mil;
        var time = new Date();
        hr = time.getHours();
        min = time.getMinutes();
        sec = time.getSeconds();
        mil = time.getMilliseconds();
        this.setState({ hr, min, sec, mil });
    }
    componentDidMount = () => {
        setInterval(this.date, 200)
    }
    render(){
        return (
            <span className='time'>{this.state.hr}:{this.state.min}:{this.state.sec} {/*. <span className='mill'>{this.state.mil}</span> */} </span>
        )
    }
}
